import { useMemo } from 'react';

import { useBoolean } from '@bonusly/design-system';
import { useCurrentUser } from '@bonusly/who-am-i';

import { Bonus } from '../../../../../../types/bonus';
import { byProperty } from '../../../utils/array';

const DEFAULT_COMMENTS_DISPLAYED = 2;

export const useCommentDisplay = (source: Bonus[], isModalDisplay: boolean | undefined = false, feedFilter: string | undefined = '') => {
	const [showAll, { toggle }] = useBoolean(isModalDisplay);
	const { id } = useCurrentUser();

	const commentsByUser = useMemo(() => {
		return [...source].filter((comment) => comment.giver.id === id);
	}, [source, id]);

	const comments = useMemo(() => {
		// NOTE: default to only showing user's comments when viewing the for you feed and there are comments by the user
		if (!showAll && feedFilter === 'for_you:given' && commentsByUser && commentsByUser.length > 0) {
			return commentsByUser;
		}
		return [...source].sort(byProperty('created_at', 'asc')).slice(showAll ? undefined : DEFAULT_COMMENTS_DISPLAYED * -1);
	}, [showAll, source, feedFilter, commentsByUser]);

	return {
		comments,
		displayed: comments.length,
		showToggle: source.length > 2,
		onToggle: toggle,
		showAll,
		total: source.length,
	};
};
